import { keccak256 } from 'ethers';

export function hashToKeccak(value: string): string {
  return keccak256(Buffer.from(value, 'utf-8'));
}
